import {Divider, Flex, Stack} from '@chakra-ui/react'
import React from 'react'
import {FormattedMessage} from 'react-intl'
import {useCurrentBasket} from '../../../hooks/use-current-basket'
import OrderSummaryHeading from '../../../components/order-summary/order-summary-heading'
import OrderSummaryList from '../../../components/order-summary/order-summary-list'
import OrderSummaryListItem from '../../../components/order-summary/order-summary-list-item'
import OrderSummaryPriceAdjustmentItem from '../../../components/order-summary/order-summary-price-adjustment-item'
import OrderSummaryPromoForm from '../../../components/order-summary/order-summary-promo-form'
import OrderSummaryProvider from '../../../components/order-summary/order-summary-provider'
import OrderSummaryShipping from '../../../components/order-summary/order-summary-shipping'
import OrderSummarySubtotal from '../../../components/order-summary/order-summary-subtotal'
import OrderSummaryTax from '../../../components/order-summary/order-summary-tax'
import OrderSummaryTotal from '../../../components/order-summary/order-summary-total'
import CartOrderProductCount from './cart-order-product-count'
import OrderSummaryVat from '../../../components/order-summary/order-summary-vat'

const CartOrderSummary = () => {
    const {
        data: basket,
        derivedData: {totalItems}
    } = useCurrentBasket()
    return (
        <OrderSummaryProvider basket={basket}>
            <Stack data-testid="sf-order-summary" spacing={6} paddingTop={4}>
                <Flex flexDirection="column" gap={3}>
                    <OrderSummaryHeading>
                        <FormattedMessage
                            defaultMessage="Order Summary"
                            id="global.order_summary"
                        />
                    </OrderSummaryHeading>
                    <CartOrderProductCount totalItems={totalItems} textStyle="Regular Medium" />
                </Flex>
                <Divider colorScheme="stokkeGray" />
                <OrderSummaryList>
                    <OrderSummaryListItem>
                        <OrderSummarySubtotal />
                    </OrderSummaryListItem>
                    {basket.orderPriceAdjustments?.map((adjustment) => (
                        <OrderSummaryListItem key={adjustment.priceAdjustmentId}>
                            <OrderSummaryPriceAdjustmentItem adjustment={adjustment} />
                        </OrderSummaryListItem>
                    ))}
                    <OrderSummaryListItem>
                        <OrderSummaryShipping />
                    </OrderSummaryListItem>
                </OrderSummaryList>
                <Divider colorScheme="stokkeGray" />
                <OrderSummaryPromoForm />
                <Divider colorScheme="stokkeGray" />
                <OrderSummaryList spacing={2}>
                    <OrderSummaryListItem>
                        <OrderSummaryTax />
                    </OrderSummaryListItem>
                    <OrderSummaryListItem>
                        <OrderSummaryVat />
                    </OrderSummaryListItem>
                </OrderSummaryList>
                <Divider colorScheme="stokkeGray" />
                <OrderSummaryList>
                    <OrderSummaryListItem>
                        <OrderSummaryTotal />
                    </OrderSummaryListItem>
                </OrderSummaryList>
            </Stack>
        </OrderSummaryProvider>
    )
}

export default CartOrderSummary
